import styled from 'styled-components'
import { theme } from '@/client/components'
import font from '@/client/components/theme/font'
const { borders, color, space, breakpoint } = theme

export const Featured = styled.div`
  padding-bottom: ${space.xl3};

  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.lg} 0 ${space.xl3};
  }
`

export const MainFeatured = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  @media (min-width: ${breakpoint.xl}) {
    flex-direction: row;
    padding-top: ${space.xl};
  }
`

export const DieGenerator = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: ${space.lg};

  .collapse-header-ch {
    font-weight: ${font.weight.bold} !important;
  }

  .collapse-header-ch,
  .collapse-children-ch {
    color: black;
    line-height: 1.2;
  }

  @media (min-width: ${breakpoint.xl}) {
    width: 49%;
    border-radius: ${borders.radius.xl};

    .collapse-header-ch {
      padding: 3rem 0 0;
    }

    .collapse-children-ch {
      padding: 1rem 0 0;
    }

    .collapse-content-ch {
      height: auto;
    }
  }
`

export const Form = styled.div`
  padding: ${space.xl} ${space.xl2};
  background-color: ${color.grayscale.lighter};
  border-radius: 0 0 ${borders.radius.lg} ${borders.radius.lg};
`

export const Block = styled.div`
  padding-bottom: ${space.xl3};
`

export const Option = styled.div<{ direction?: string; isFull?: boolean }>`
  display: flex;
  flex-direction: ${(p) => p.direction ?? 'row'};
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: ${(p) => (p.isFull ? 'nowrap' : 'wrap')};
  gap: ${space.sm};
`

export const Hint = styled.sup`
  margin-left: ${space.xs2};
  cursor: help;
`
export const CardHeader = styled.div`
  width: 100%;
  background-color: ${color.grayscale.darkNavyBlue};
  @media (min-width: ${breakpoint.lg}) {
    border-radius: ${borders.radius.xl} ${borders.radius.xl} 0 0;
    transition: border-radius 0.4s ease-in-out;
  }
`
export const DividerLine = styled.div`
  background-color: ${color.grayscale.black};
  margin-top: ${space.lg};
  margin-right: ${space.lg};
  margin-left: ${space.lg};
  width: 90%;
  height: 0.09rem;

  @media (min-width: ${breakpoint.md}) {
    background-color: ${color.grayscale.black};
    margin-top: ${space.lg};
    margin-right: 0;
    margin-left: 0;
    width: 100%;
    height: 0.09rem;
  }
`

export const ContentInfos = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${space.xl};

  @media (min-width: ${breakpoint.xl}) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
`
export const ContentLeft = styled.div`
  width: 100%;
  margin-top: ${space.lg};

  @media (min-width: ${breakpoint.xl}) {
    width: 70%;
    margin-top: 0;
  }
`

export const ContentRight = styled.div`
  .tutorial_image {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
    top: ${space.lg};
  }
`
export const TopTriangle = styled.div<{ isVisible: boolean }>`
  display: none;

  @media (min-width: ${breakpoint.xl}) {
    display: block;
    margin-bottom: ${space.xs};
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 20px solid ${color.grayscale.darkNavyBlue};
    visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
    left: 50%;
    position: relative;
  }
`
